/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component } from "react";
import { connect } from "react-redux";

import { saveHistoryCheckboxesValues } from "../../reduxStore/actions/dashboard";

import Label from "../../components/label";
import ICDateInput from "../../components/form/dateInput";
import ConsultHistoryList from "../../containers/ConsultHistoryList";
import MakeAPICall from "../../apiCalls/common";
import ICIconBtn from "../../components/iconButton";
import moment from "moment";
import ICCheckbox from "../../components/form/checkbox";

import { converToUtc } from "../../utils/dateTimeHelper";
import ICSelect from "../../components/form/selectInput";
import { STATE_LIST } from "../../constants/helperConstants";
import { Slider } from "@material-ui/core";

const AGE_MARKS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120].map((val) => { return { value: val, label: val } })

class ConsultHistoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      states: [{
        stateId: "None"
      }, ...STATE_LIST],
      apiCall: "",
      startDate:
        this.props.dashboard.historyCheckboxes.startDate === null ||
        this.props.dashboard.historyCheckboxes.startDate === undefined
          ? new Date(
            moment()
              .subtract(7, "days")
              .format("MM/DD/YYYY")
          ).toISOString()
          : this.props.dashboard.historyCheckboxes.startDate,
      endDate:
        this.props.dashboard.historyCheckboxes.endDate === null ||
        this.props.dashboard.historyCheckboxes.endDate === undefined
          ? new Date().toISOString()
          : this.props.dashboard.historyCheckboxes.endDate,
      gender: undefined,
      state: undefined,
      ageRangeChecked: false,
      ageRange: [0, 130],
      earning: {},
      filterByDateCall: false,
      filterActive: true,
      todayDateCheckbox: this.props.dashboard.historyCheckboxes.today,
      thisWeekDateCheckbox: this.props.dashboard.historyCheckboxes.thisWeek
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  updateEarningData = data => {
    this.setState({ earning: data });
  };

  filterByDate = () => {
    this.setState({
      filterByDateCall: !this.state.filterByDateCall,
      filterActive: false
    });
  };

  cancelFilterByDate = () => {
    let dataObj = {
      filterActive: true,
      startDate: new Date(
        moment()
          .subtract(7, "days")
          .format("MM/DD/YYYY")
      ).toISOString(),
      endDate: new Date().toISOString()
    };

    this.setState({
      filterActive: dataObj.filterActive,
      startDate: dataObj.startDate,
      endDate: dataObj.endDate,
      filterByDateCall: !this.state.filterByDateCall,
      todayDateCheckbox: false,
      thisWeekDateCheckbox: false
    });

    this.props.saveHistoryCheckboxesValues({
      today: false,
      thisWeek: false,
      startDate: null,
      endDate: null
    });
  };

  applyTodayDateFilter = event => {
    this.setState({
      todayDateCheckbox: event.target.checked,
      thisWeekDateCheckbox: false
    });

    if (event.target.checked === true) {
      const startOfDayDate = moment().startOf('d').toISOString();
      const endOfDayDate = moment().endOf('d').toISOString();
      this.setState({
        startDate: startOfDayDate,
        endDate: endOfDayDate
      });

      this.props.saveHistoryCheckboxesValues({
        today: event.target.checked,
        thisWeek: false,
        startDate: startOfDayDate,
        endDate: endOfDayDate
      });

      this.filterByDate();
    } else {
      this.props.saveHistoryCheckboxesValues({
        today: event.target.checked,
        thisWeek: false,
        startDate: null,
        endDate: null
      });
    }
  };

  applyThisWeekDateFilter = event => {
    this.setState({
      thisWeekDateCheckbox: event.target.checked,
      todayDateCheckbox: false
    });

    let currDate = new Date();
    let day = currDate.getDay(),
      diff = currDate.getDate() - day + (day === 0 ? -6 : 1);

    if (event.target.checked === true) {
      this.setState({
        startDate: new Date(new Date().setDate(diff)).toISOString(),
        endDate: new Date(new Date().setDate(diff + 6)).toISOString()
      });

      this.props.saveHistoryCheckboxesValues({
        thisWeek: event.target.checked,
        today: false,
        startDate: new Date(new Date().setDate(diff)).toISOString(),
        endDate: new Date(new Date().setDate(diff + 6)).toISOString()
      });

      this.filterByDate();
    } else {
      this.props.saveHistoryCheckboxesValues({
        thisWeek: event.target.checked,
        today: false,
        startDate: null,
        endDate: null
      });
    }
  };

  render() {
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;

    return (
      <div className="row rounded p-3 consult-history-page">
        {/* Top Filters */}
        <div className="col-sm-12 pt-3 pl-3">
          <Label title="Consult History" className="big" />
        </div>
        <div
          className="row col-md-12 pl-3 pt-2 pr-0 pb-3 d-flex flex-row flex-wrap justify-content-between align-baseline">
          <div className="row col-sm-12">
            <div className="col-sm-3 pt-2">
              <ICDateInput
                id="startdate"
                className="cal-primary-bg mt-2"
                label="Start Date"
                defaultDate={this.state.startDate}
                handleChange={date =>
                  this.setState({ startDate: date, filterActive: true, thisWeekDateCheckbox: false, todayDateCheckbox: false })
                }
                filterOn={this.state.startDate}
              />
            </div>
            <div className="col-sm-3 pt-2 pr-0">
              <ICDateInput
                id="endDate"
                className="cal-primary-bg mt-2"
                label="End Date"
                defaultDate={this.state.endDate}
                handleChange={date =>
                  this.setState({ endDate: date, filterActive: true })
                }
                filterOn={this.state.endDate}
              />
            </div>
            <div className="row flex-grow-1"></div>
            <div>
              <div className="row">
                <Label
                  className="col-md-7 m-0 p-0 d-flex align-items-center justify-content-end"
                  title="Today"
                />
                <div className="col-md-5 ic-checkbox-container">
                  <ICCheckbox
                    name="todayDateCheckbox"
                    onChange={this.applyTodayDateFilter}
                    value={this.state.todayDateCheckbox}
                  />
                </div>
              </div>
              <div className="row">
                <Label
                  className="col-md-7 m-0 p-0 d-flex align-items-center justify-content-end"
                  title="This Week"
                />
                <div className="col-md-5 ic-checkbox-container">
                  <ICCheckbox
                    name="thisWeelDateCheckbox"
                    onChange={this.applyThisWeekDateFilter}
                    value={this.state.thisWeekDateCheckbox}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row flex-grow-1 mt-1">
            <div className="ml-4 row col-sm-5">
              <Label className="gray small" title="Age Range"/>
              <Slider
                className='primary-color'
                marks={AGE_MARKS}
                min={0}
                max={130}
                value={this.state.ageRange}
                onChange={(e, ageRange)=> {
                  this.setState({ ageRange, filterActive: true });
                }}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
              />
            </div>

            <div className="row col-sm-5">
              <div className="col-sm-6">
                <Label className="gray small" title="Gender" required={true} />
                <ICSelect
                  label=""
                  placeholder="Select Gender"
                  useId="_id"
                  useValue="val"
                  items={[
                    { _id: "None", val: 'None' },
                    { _id: "Male", val: "Male" },
                    { _id: "Female", val: "Female" }
                  ]}
                  value={this.state.gender}
                  handleChange={val => {
                    this.setState({
                      gender: val === "None" ? undefined : val,
                      filterActive: true
                    });
                  }}
                />
              </div>

              <div className="col-sm-6">
                <Label className="gray small" title="State" required={true} />
                <ICSelect
                  label=""
                  placeholder="Select State"
                  items={this.state.states}
                  useId="stateId"
                  useValue="stateId"
                  value={this.state.state}
                  handleChange={val => {
                    this.setState({
                      state: val === "None" ? undefined : val,
                      filterActive: true
                    });
                  }}
                />
              </div>
            </div>
            <ICIconBtn
              title=""
              className={
                this.state.filterActive ? "font-15 only-icon mt-4" : "d-none"
              }
              type="button"
              clickEvent={this.filterByDate}
              icon="fas fa-arrow-right"
            />

            <ICIconBtn
              title=""
              className={
                !this.state.filterActive
                  ? "font-15 only-icon danger mt-4"
                  : "d-none"
              }
              type="button"
              clickEvent={this.cancelFilterByDate}
              icon="fas fa-times"
            />
          </div>
        </div>

        <div className="col-sm-12 border-bottom"></div>

        {/* Consultations / Avg Duration of Consult / Earnign  */
        }
        <div className="col-sm-4 p-2 mt-2 pl-0 pr-0">
          <div className="small-cards rounded text-center">
            <Label title="Consultations" className="w-100 gray font-17" />
            <Label
              title={this.state.earning.totalConsultation}
              className="primary-font big"
            />
          </div>
        </div>

        <div className="col-sm-4 p-2 mt-2 pl-0 pr-0">
          <div className="small-cards rounded text-center">
            <Label
              title="Avg. Duration of Consult"
              className="w-100 gray font-17"
            />
            <Label
              title={this.state.earning.duration}
              className="primary-font big"
            />
          </div>
        </div>

        <div className="col-sm-4 p-2 mt-2 pl-0 pr-0">
          <div className="small-cards rounded text-center">
            <Label title="Earnings" className="w-100 gray font-17" />
            <Label
              title={this.state.earning.earnings}
              className="primary-font big"
            />
          </div>
        </div>

        <div className="col-sm-12 mt-4">
          <ConsultHistoryList
            makeAPICall={this.componentAPICall}
            startDate={startDate}
            endDate={endDate}
            gender={this.state.gender}
            state={this.state.state}
            ageRange={this.state.ageRange}
            updateAggregateData={this.updateEarningData}
            filterByDateCall={this.state.filterByDateCall}
          />
        </div>

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  dashboard: state.dashboard
});

const mapDispatchToProps = dispatch => ({
  saveHistoryCheckboxesValues: data =>
    dispatch(saveHistoryCheckboxesValues(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ConsultHistoryPage);
